//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductCard from "./products/ProductCard";
import Pagination from "~/components/Pagination.vue";

export default {

  props: {
    curPage: {},
    content: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    section: {
      type: Object,
      default: () => {
        return {}
      }
    },
    activeCategory: {
      type: String,
      reuqired: false,
      default () {
        return ''
      }
    }
  },

  computed: {
    totalPages: function () {
      return Math.ceil(this.section?.total / 30);
    },
    isShowPagination: function () {
      return Boolean(this.section?.total > this.section?.length);
    }
  },

  components: {
    Pagination,
    ProductCard,

    PagePagination: () => import("~/components/Pagination.vue")
  },

  methods: {
    onChangePage: function (page) {
      this.$emit("changePageSearch", page);
    }
  }

}
